<div style="margin: 0 auto; background-color: #E6F4F1;">
  <ngx-graph #graph layout="dagreCluster" [nodes]="nodes" [links]="links" [clusters]="clusters"
    [layoutSettings]="layoutSetting" [curve]="curve" [draggingEnabled]="false" [panningEnabled]="true" [autoZoom]="true"
    [autoCenter]="true" [enableZoom]="true" [center$]="center$" [zoomToFit$]="zoomToFit$">
    <!-- [autoZoom]="true" [autoCenter]="true" -->

    <ng-template #defsTemplate>
      <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto"
        (click)="a(arrow)">
        <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
      </svg:marker>
    </ng-template>

    <ng-template #nodeTemplate let-node>
      <svg:g class="node" (click)="openCourse(node)" ngx-tooltip [tooltipPlacement]="'top'" [tooltipType]="'tooltip'"
        [tooltipTitle]="node.tooltip">
        <svg:rect rx="5" ry="5" [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
          [attr.fill]="node.data.customColor" />
        <svg:text alignment-baseline="center" [attr.fill]="node.data.customFontColor" [attr.x]="10" [attr.y]="19">
          {{node.label}}</svg:text>
      </svg:g>
    </ng-template>

    <ng-template #linkTemplate let-link>
      <svg:g class="edge" (click)="a(link)" [ngStyle]="{'stroke': link.data.customColor}">
        <svg:path *ngIf="link.data.customColor !== '#ffffff00'" class="line" stroke-width="2" marker-end="url(#arrow)">
        </svg:path>
      </svg:g>
    </ng-template>


    <ng-template #clusterTemplate let-cluster>
      <svg:g class="node cluster">
        <svg:rect rx="5" ry="5" [attr.width]="cluster.dimension.width" [attr.height]="cluster.dimension.height"
          [attr.fill]="cluster.data.customColor" />
      </svg:g>
    </ng-template>
  </ngx-graph>
</div>
